// extracted by mini-css-extract-plugin
module.exports = {"forWhomBlock":"ForWhomBlock_forWhomBlock__MtVS2","forWhomBlock_img":"ForWhomBlock_forWhomBlock_img__u8Rlz","forWhomBlock_text":"ForWhomBlock_forWhomBlock_text__jUtyM"};